// Single transport for client-recorded CustomerJourneyEvents from the Vite world
// (game board / tracker / scanner). This is the Vite-side TWIN of
// app/javascript/lib/journeyEvents.js (the importmap/Stimulus world) — the two
// cannot import across the Vite/importmap boundary, so keep them in sync.
//
// POSTs to Api::V2::JourneyEventsController, which is CSRF-exempt like every
// /api controller, so NO X-CSRF-Token header is sent. `keepalive: true` lets the
// request survive a navigation that follows the call. The server owns everything
// that matters (allowed event types, dedupe, metadata whitelist); a rejected or
// duplicate event is silently ignored here.
//
// Hard rule: this must NEVER throw into the board. A telemetry failure can't be
// allowed to break the game, so every path is wrapped.
const ENDPOINT = '/api/v2/journey_events';

export function recordJourneyEvent(eventType, metadata = {}) {
  if (!eventType) return;

  try {
    fetch(ENDPOINT, {
      method: 'POST',
      keepalive: true,
      // Explicit: guest dedupe depends on the server-set cj_sid session cookie
      // round-tripping. Without credentials every guest beacon writes a new row.
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ event_type: eventType, metadata }),
    }).catch(() => {});
  } catch (_e) {
    // Telemetry never blocks the user. Losing one event is fine.
  }
}
